import React from "react";

export default function CustomReportingResults() {
  return <div>CustomReportingResults</div>;
}
